import BusinessBookDisabledListContainer from './BusinessBookDisabledListContainer';
import BusinessBookDisabledDetailContainer from './BusinessBookDisabledDetailContainer';

const businessBookDisabledContainers = [
  { path: "/business-book-disabled/list", component: BusinessBookDisabledListContainer },
  { path: "/business-book-disabled/:businessBookDisabledId", component: BusinessBookDisabledDetailContainer },
]

export default businessBookDisabledContainers
